export default [
    {
        path: '/activity/cup/europe',
        name: 'record',
        component: () => import("../views/activity/europe/record.vue")
    },
    {
        path: '/activity/worldCup/luckDraw',
        name: 'luckDraw',
        component: () => import("../views/activity/worldCup/luckDraw.vue")
    },
    {
        path: '/activity/worldCup/rule',
        name: 'rule',
        component: () => import("../views/activity/worldCup/rule.vue")
    },
    {
        path: '/activity/redEnvelopes/details',
        name: 'redEnvelopes',
        component: () => import("../views/activity/worldCup/redEnvelopes.vue")
    },
    // 抽奖相关
    {
        path: '/activity/lotteryDraw/index',
        name: 'lotteryDraw',
        component: () => import("../views/activity/lotteryDraw/draw.vue")
    },
    {
        path: '/activity/lotteryDraw/record',
        name: 'lotteryRecord',
        component: () => import("../views/activity/lotteryDraw/record.vue")
    }
]
